console.info(import.meta.env);

export const environment = {
    exploratronBaseUrl: import.meta.env['VITE_EXPLORATRON_BASE_URL'],
    eventotronBaseUrl: import.meta.env['VITE_EVENTOTRON_BASE_URL'],
};
